import {
  LayoutListDefinition,
  LAYOUT_LIST,
  QUESTION_SEQUENCE,
  QUIZ_CHOICE,
  CAROUSEL,
  CarouselDefinition,
  CardDefinition
} from '../items';
import { QuestionSequenceDefinition } from '../items/question-sequence/QuestionSequence';
import { Translator } from '../Translator';
import { AnswerButtonHelper } from './itemHelpers/AnswerButtonHelpers';
import { CardHelper } from './itemHelpers/CardHelper';
import { TextHelper } from './itemHelpers/TextHelper';
import { ItemOfType } from './itemHelpers/types';
import { quizLegendText } from './itemHelpers/Quiz';
import { translate } from './translate';
import { useEditorStore } from '~/shell/Store';
import { OPTIONAL_TEXT_FIELDS } from '../utils/optionalFields';

export const Cards7: Translator = sequence => {
  const { editorMode, contentEditable } = useEditorStore.getState();

  const cardsList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.cardlist`,
    values: {
      orientation: { _: 'column', sm: 'row' },
      align: 'center',
      padded: true,
      type: 'ul'
    },
    items: [
      {
        id: `${sequence.id}.questionsequence`,
        type: QUESTION_SEQUENCE,
        values: void {},
        items: []
      } as QuestionSequenceDefinition
    ]
  } as LayoutListDefinition;

  const mainList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.list`,
    values: {
      orientation: 'column',
      align: 'center',
      padded: true
    },
    items: []
  } as LayoutListDefinition;

  const root = translate(sequence, item => {
    if (item.__typename === 'Question') {
      cardsList.items[0].items.push(
        CardHelper(item as ItemOfType<'Question'>, {
          height: 'unset',
          width: editorMode && contentEditable ? '360px' : '269px',
          padding: '0px',
          isImageDecorative: true,
          type: 'li',
          extraType: 'ul',
          audioPadding: '0px',
          optional: OPTIONAL_TEXT_FIELDS,
          extraItems: [
            {
              id: `${item.id}.quiz`,
              type: QUIZ_CHOICE,
              values: {
                title: quizLegendText(item.title, item.body),
                length: item?.items?.length,
                maxLength: 2,
                multiSelect: item?.items?.filter(item => item.correct === true)
                  .length,
                // Multi-card template: scope answer feedback to each card so
                // one card's feedback doesn't show on all cards.
                weNeedToUseOwnFeedback: true
              },
              items: AnswerButtonHelper({
                group: item.id,
                items: item.items,
                linkedAudioId: item.audios?.[0]?.id,
                llamaSurvey: item.llamaSurvey,
                question: item.title || ''
              })
            }
          ]
        })
      );
    } else if (item.__typename === 'Card') {
      cardsList.items[0].items.push(
        CardHelper(item as ItemOfType<'Card'>, {
          height: 'unset',
          width: '269px',
          padding: '0px',
          isImageDecorative: true,
          type: 'li',
          canWeDeleteCard: editorMode && contentEditable,
          optional: OPTIONAL_TEXT_FIELDS
        })
      );
    } else if (item.__typename === 'Text') {
      mainList.items = [
        {
          type: LAYOUT_LIST,
          id: `${sequence.id}.list`,
          values: {
            orientation: 'column',
            align: 'top',
            padded: false
          },
          items: TextHelper(item as ItemOfType<'Text'>, {
            optional: OPTIONAL_TEXT_FIELDS
          })
        } as LayoutListDefinition
      ];
    }

    return null;
  });

  if (editorMode && contentEditable) {
    root.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.list`,
      values: {
        orientation: 'column',
        align: 'top',
        padded: true
      },
      items: [...mainList.items]
    } as LayoutListDefinition);

    root.items.push({
      type: CAROUSEL,
      id: `${sequence.id}.carousel`,
      values: {
        variant: 'horizontal',
        showProgressBar: false,
        cssStylesForItem: {
          'place-self': 'flex-end',
          height: '80%'
        },
        itemType: 'QUESTION'
      },
      items: cardsList.items[0].items
    } as CarouselDefinition);
  } else {
    mainList.items.push(cardsList);

    if (mainList.items.length > 1) {
      mainList.items.push({
        type: LAYOUT_LIST,
        id: `${sequence.id}.blank`
      } as LayoutListDefinition);
    }
    root.items.push(mainList);
  }

  return root;
};
